import React, { useState, useEffect } from "react";

const FooterHyfye = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [ip, setIp] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch IP Address
  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(res => res.json())
      .then(data => setIp(data.ip))
      .catch(err => console.error("IP fetch error:", err));
  }, []);

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email) && email.length <= 150;
  };

  const canSubscribe = () => {
    const record = JSON.parse(localStorage.getItem("subscribeRecord")) || {};
    const lastTime = record[ip];
    return !lastTime || (Date.now() - lastTime) > 24 * 60 * 60 * 1000;
  };

  const saveSubscribeTime = () => {
    const record = JSON.parse(localStorage.getItem("subscribeRecord")) || {};
    record[ip] = Date.now();
    localStorage.setItem("subscribeRecord", JSON.stringify(record));
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (!canSubscribe()) {
      setError("You have already subscribed today. Try again after 24 hours.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://api.brevo.com/v3/contacts', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "api-key": "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",
        },
        body: JSON.stringify({
          email: email,
          listIds: [3], // Your List ID
          attributes: { IP: ip }
        }),
      });

      if (response.ok) {
        setSuccess("✅ Subscribed successfully! Welcome to Hyfye.");
        saveSubscribeTime();
        setEmail("");
      } else {
        const data = await response.json();
        console.error("Brevo error:", data);
        setError(data.message || "Something went wrong. Please try again later.");
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="top_footer bg_light_dark" data-z-index="1" data-parallax="scroll" data-image-src="assets/images/footer_bg.png">
        <div className="container">
          <div className="row">

            {/* Left Side */}
            <div className="col-lg-4 col-md-12">
              <div className="footer_logo mb-3">
                <a href="#home_section" className="page-scroll">
                  <img alt="Hyfye Logo" src="assets/images/logo.png" className="logo_light" />
                </a>
              </div>
              <div className="footer_desc">
  <p>Hyfye transforms appreciation into real-world value. Every action — a like, a comment, a tip — fuels a decentralized economy where everyone can earn, connect, and grow. One global coin. Infinite gratitude.</p>
</div>

            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6 res_md_mt_30 res_sm_mt_20">
              <h4 className="footer_title border_title">Quick Links</h4>
              <ul className="footer_link list_arrow">
                <li><a href="#about">About Hyfye</a></li>
                <li><a href="#how_it_work">How It Works</a></li>
                <li><a href="#token">Tokenomics</a></li>
                <li><a href="#faq">FAQ</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>

            {/* Subscribe Form */}
            <div className="col-lg-5 col-md-6 res_md_mt_30 res_sm_mt_20">
              <div className="newsletter_form">
                <h4 className="footer_title border_title">Stay Updated</h4>
                <p>Subscribe for the latest news, token sales, and platform updates delivered directly to you.</p>
                <form onSubmit={handleSubscribe} className="subscribe_form">
                  <input
                    className="input-rounded"
                    type="email"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" title="Subscribe" className="btn-info" disabled={loading}>
                    {loading ? "Subscribing..." : "Subscribe"}
                  </button>
                </form>
                {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
                {success && <p style={{ color: "lightgreen", marginTop: "10px" }}>{success}</p>}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bottom_footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p className="copyright">
                Copyright &copy; 2025 Hyfye. All Rights Reserved.
              </p>
            </div>
            <div className="col-md-6">
              <ul className="list_none footer_menu">
                <li><a href="/assets/document/hyfye-official.pdf" download>Privacy Policy</a></li>
                <li><a href="/assets/document/hyfye-official.pdf" download>Terms & Conditions</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterHyfye;
